<template>
  <div>
    <!-- 상단 - 요청서 제목 / 스텝 / 저장 영역 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveForm">저장하기</button>
    </div>
    <div class="box">
      <div class="columns is-multiline">
        <div class="column is-full lp-content">
          <input v-model="meet.title"  maxlength="30"
                 placeholder="새로운 모임참여 이름을 입력하세요." style="margin-bottom:12px">
        </div>
        <div class="column is-full">
          <admin-form-item label="견적서 발송 방식">
            <div style="display:table">
              <div style="display:table-cell;padding-right:12px;padding-top:3px">
                <lp-check-bool :checkedVal.sync="meet.activate"
                               label="발행하기"></lp-check-bool>
                <div class="lp-admin-savedate-txt" v-if="meet.updated_time">최근 저장일 {{ meet.updated_time }}</div>
              </div>
            </div>
          </admin-form-item>
        </div>
      </div>
    </div>

    <div class="box lp-content">
      <draggable v-model="meet.forms" :options="{handle:'.lp-drag-btn'}">
        <div v-for="(form,idx) in meet.forms" :key="'form-'+idx"
             class="lp-step-form" @click="clickForm(form)"
             :class="{'lp-step-form-clicked':form.clicked}">
          <div class="lp-drag-btn"><i class="material-icons">dehaze</i></div>
          <!-- 타입별 요소 -->
          <div class="flex-justify">
            <div style="margin-right: 20px;flex:1">
              <input v-model="form.question" placeholder="질문을 입력해주세요">
            </div>
            <!-- 요소 선택 -->
            <div>
              <form-element-dr-dn :ele="form.type" :formtypes="formtypes"
                                  @clickEl="res => clickEl(form, res)"></form-element-dr-dn>
            </div>
          </div>

          <div v-if="form.type.search('text')>-1">
            <input v-model="form.placeholder" placeholder="Placeholder 입력">
          </div>

          <!-- 옵션 입력 -->
          <div class="lp-opt-div" v-for="(opt, opt_idx) in form.opts" :key="'opt-'+opt_idx">
            <div :class="optIcon(form.type)"><span v-if="form.type === 'dropdown'">{{ opt_idx+1 }}</span></div>
            <div style="flex:1" v-if="opt.value !== 'etc..'"><input v-model="opt.value" placeholder="옵션을 입력해주세요." ></div>
            <div style="flex:1;padding-top:15px" v-else>기타</div>
            <div class="btn-del" v-if="idx > 0" @click="removeIndex(form.opts,opt_idx)"><i class="material-icons">close</i></div>
          </div>
          <div style="display:flex" v-if="form.opts.length>0">
            <div :class="optIcon(form.type)"><span v-if="form.type === 'dropdown'">{{ form.opts.length + 1 }}</span></div>
            <div class="add-opt-txt" @click="addOpt(form.opts)">옵션 추가</div>
            <div class="add-opt-etc" v-if="!vEtc(form.opts)" @click="addOptEtc(form.opts)">기타 추가</div>
          </div>

          <!-- 범위 -->
          <div v-if="form.type === 'linear'" class="flex">
            <lp-dropdown :options="opts.min" :ele.sync="form.range.min.val"></lp-dropdown> <div class="wave"> ~ </div>
            <lp-dropdown :options="opts.max" :ele.sync="form.range.max.val"></lp-dropdown>
          </div>
          <div v-if="form.type === 'linear'">
            <div class="flex"><div class="range-label-title">{{ form.range.min.val }}</div><input v-model="form.range.min.label"></div>
            <div class="flex"><div class="range-label-title">{{ form.range.max.val }}</div><input v-model="form.range.max.label"></div>
          </div>

          <!-- 토글 -->
          <div class="lp-toggle">
            <div class="lp-toggle-item" @click="copyForm(form, idx)"><i class="material-icons">content_copy</i></div>
            <div class="lp-toggle-item" @click="removeForm(idx)"><i class="material-icons">delete</i></div>
            <div class="lp-toggle-in">
              <div style="display: table-cell">
                <toggle-button @change="e=>setRequired(form, e)" :sync="true"
                               :value="form.required" class="changed-font" :width="70" :height="24"
                               :labels="{'checked':'필수', 'unchecked':'옵션'}"></toggle-button>
              </div>
              <div style="display: table-cell">
                <div style="margin-left:8px">
                  <toggle-button @change="e=> form.visible = e.value" :sync="true"
                                 :value="form.visible" class="changed-font" :width="70" :height="24"
                                 :labels="{'checked':'노출', 'unchecked':'비노출'}"></toggle-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="text-align: center" slot="footer">
          <div class="btn-add" @click="addStepForm">질문하기 +</div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import FormElementDrDn from '../../module/common/FormElementDrDn'
  import LpDropdown from '../../module/common/LpDropdown'
  import LpSortDropDown from "../../module/common/LpSortDropDown";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import AdminFormItem from "../../module/admin/AdminFormItem";

  export default {
    layout: 'Main',
    components: {
      AdminFormItem,
      LpCheckBool,
      LpAdmDropInput,
      LpSortDropDown,
      draggable,
      FormElementDrDn,
      LpDropdown
    },
    created() {
      if(this.$route.query.id)
        this.is_modify = true;

      // 관리자 id 반영
      //this.meet.admin_id = this.$store.getters.admin.username;

      //범위용 드롭다운 데이터 생성
      for(let i=0; i<=10; i++) {
        if(i<2) this.opts.min.push({ value:i, label:i });
        else this.opts.max.push({ value:i, label:i });
      }

      this.getData();
    },
    data() {
      return {
        is_modify:false,
        formtypes: [{
          icon:"short_text",
          id: 1,
          name: "단답형",
          types: "text",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"subject",
          id: 2,
          name: "장문형",
          types: "textarea",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"radio_button_checked",
          id: 3,
          name: "객관식 질문",
          types: "radio",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"check_box",
          id: 4,
          name: "체크박스",
          types: "checkbox",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"arrow_drop_down_circle",
          id: 5,
          name: "드롭다운",
          types: "dropdown",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"cloud_upload",
          id: 6,
          name: "파일 업로드",
          types: "fileupload",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"insert_invitation",
          id: 7,
          name: "날짜",
          types: "date",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"access_time",
          id: 9,
          name: "시간",
          types: "time",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"place",
          id: 10,
          name: "지역",
          types: "region",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"person",
          id: 11,
          name: "사용자 정보",
          types: "users",
          updated_date: "2018-01-12T08:30:33.585Z"
        }],
        meet: {
          id:0,
          admin_id: '',
          title: '',
          activate: true,
          updated_time: '',
          forms: [],
        },
        // 범위 옵션 용
        opts: {
          min: [],
          max: []
        }
      }
    },
    methods: {
      setRequired(form, e) {
        form.required = e.value;
        form.valid_required = e.value;
      },
      getData(){
        // 수정할 요청서 가져오기
        let id = '';
        if(this.$store.getters.mode==='admin' && this.$route.query.id){
          id = this.$route.query.id;
          this.getFormDetail(id);
        }
        /*else if(this.$store.getters.mode==='partner'){
          id = this.$store.getters.partner.partner_id;
          this.getFormDetail(id);
        }*/
      },
      optIcon(type) {
        switch(type) {
          case 'radio': return 'lp-circle';
          case 'checkbox': return 'lp-square';
          case 'dropdown': return 'lp-drdn';
        }
      },
      // 스텝 추가
      addStep() {
        //5개 까지만 추가
        if(this.meet.steps.length==5) return;
        this.meet.steps.push({
          title: '',
          selected: false,
          forms: []
        });
      },
      // 스텝 폼 추가
      addStepForm() {
        this.meet.forms.push({
          type: 'text',
          placeholder: '',
          clicked: false,
          required: true,
          valid_required: true,
          visible: true,
          opts:[],              // 옵션(체크박스, 라디오, 드롭다운)
          range: {              // 범위(직선단계)
            min: {
              val: 1,
              label: ''
            },
            max: {
              val: 5,
              label: ''
            }
          }
        });
      },
      //폼 선택
      clickForm(forms) {
        if(this.selectedForm !== undefined)
          this.selectedForm.clicked = false;

        forms.clicked = true;
        this.selectedForm = forms;
      },
      // 타입 선택
      clickEl(el, type) {
        el.type = type;
        // 옵션 없는 타입
        let not_opts = ['text', 'textarea', 'fileupload', 'linear', 'region','users', 'address'];

        if(not_opts.indexOf(type) === -1) {
          el.opts = [{
            value: '옵션 1'
          }];
        }
        else {
          el.opts = [];
        }

      },
      // 옵션 추가
      addOpt(opts) {
        opts.push({
          value: '옵션 ' + (opts.length+1)
        })
      },
      // 옵션 기타 추가
      addOptEtc(opts) {
        opts.push({
          value: 'etc..'
        })
      },
      //폼 복사
      copyForm(form, idx) {
        let forms = this.cloneItem(form);
        forms.selected = false;
        this.meet.forms.splice(idx+1, 0, forms);
      },
      //폼 삭제
      removeForm(idx) {
        removeIndex(this.meet.forms,idx);
      },
      //기타 항목 추가여부
      vEtc(opts) {
        let hasEtc = false;
        for(let i=0; i< opts.length; i++) {
          if(opts[i].value === 'etc..') {
            hasEtc = true;
            break;
          }
        }

        return hasEtc;
      },
      // 폼 정보
      getFormDetail(id){
        this.meet.steps = [];
        this.$axios.get(this.getUrl('meet/form/' + id))
          .then(res => {
            if (res.status === 200) {
              this.meet = res.data;

            }
          });
      },
      // 저장
      saveForm() {
        let errMsg='';
        if(!this.meet.title) errMsg = '견적요청서 이름을 입력해주세요.';

        if(errMsg){
          this.toast(errMsg);
          return;
        }
        let url = '';
        let params = '';
        let path = '';
        if(this.$store.getters.mode==='admin'){
          if(this.is_modify){
            url = this.getUrl('meet/form')+'/'+this.$route.query.id;
            params = this.meet;
            path = this.getPath('meet/form');
            this.patchData(url, params, path);
          }
          else{
            url = this.getUrl('meet/form');
            params = this.meet;
            path = this.getPath('meet/form');
            this.postData(url, params, path);
          }
        }
       /* else if(this.$store.getters.mode==='partner'){
          url = this.getUrl('meet/form')+'/'+this.meet.id;
          params = this.meet;
          path = '/office/admin/form';
          this.patchData(url, params, path);
        }*/
      },


    }
  }
</script>

<style lang="styl" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-content input
    border 0
    border-bottom 1px solid #ddd
    padding 8px 0
    padding-bottom 2px
    border-radius 0
    font-size 0.9rem
    max-width 400px
    box-shadow 0 0 0
  .lp-content input:focus
    border-bottom 1px solid $primary


  .lp-admin-save-div
    display flex
    justify-content space-between
    background-color white
    padding 12px
    margin-bottom 20px

  .lp-admin-savedate-txt
    font-size 0.8rem
    color #555

  .lp-admin-save-btn
    width 52px
    color white
    background-color $primary
    text-align center
    padding 6px 8px
    font-size 0.9rem
    border-radius 3px
    display inline-block

  .steps
    flex 1
    //padding 0 40px
    display flex

  .step
    width 60px
    color $primary
    border 1px solid $primary
    border-radius 2px
    padding 6px 8px
    font-size 0.9rem
    text-align center
    margin auto 0
    margin-right 8px
    cursor pointer

  .step:hover
  .step-select
    color white
    background-color $primary

  input[type=checkbox]
    width unset
    height 0.82rem

  input
    width 100%

  label
    font-size 0.9rem

  .lp-step-form
    padding 20px

  .lp-step-form-clicked
    box-shadow 0px 4px 6px 2px #aaa

  .btn-add
    padding 4px 20px
    border-radius 50px
    color $primary
    border 1px solid $primary
    text-align center
    margin 20px auto
    display inline-block
    cursor pointer

  .lp-opt-div
    width 400px
    display flex
    justify-content space-between
    padding 8px 0
    align-items center

  .lp-opt-div input
    flex 1

  .flex-justify
    display flex
    justify-content space-between
    margin-bottom 20px

  .lp-drdn
  .lp-circle
  .lp-square
    width 16px
    height 16px
    /*margin-top 14px*/
    margin-right 8px

  .lp-circle
    border-radius 100%

  .lp-circle
  .lp-square
    border 2px solid #aaa

  .btn-del
    /*margin-top 8px*/
    color #999

  .add-opt-etc
  .add-opt-txt
    color #555
    margin-top 15px
    font-size 0.9rem
    cursor pointer

  .add-opt-etc
    margin-left 8px
    color $primary

  .lp-toggle
    display flex
    justify-content flex-end
    margin-top 30px
    padding 20px 0
    border-top 1px solid #ddd

  .lp-toggle-item
    margin 0 12px
    color #555

  .lp-toggle-in
    display table
    padding-left 16px
    border-left 1px solid #eee


  .vue-js-switch .v-switch-label
    font-weight 400

  .vue-js-switch.changed-font
    font-size 14px

  .wave
    line-height 43px
    margin 0 8px

  .range-label-title
    height 23px
    width 30px
    text-align center
    padding-top 16px

  .lp-drag-btn
    width 100%
    height 20px
    text-align center
    margin-bottom 12px

  .lp-drag-btn i
    color #787878
    font-size 0.9rem
    display none

  .lp-step-form:hover .lp-drag-btn i
    display block
    cursor move

  .catlabel
    margin-right 4px
    padding 4px
    font-size 0.9rem
    background-color $primary
    color white
    border-radius 3px
</style>
